import * as go from 'gojs';
import { getImageStorageWith2Outputs } from 'unitData/Storage/StorageData';
import { OutputPort } from '../../../../../gojs/templates/portTemplates/outputPortTemplate';
import {
  CONVERSIONS,
  convertToCurrentMetric,
  getMetricUnit,
} from 'util/conversions';
import { getImageBinding, getIOPort, makeNode } from '../../utils';
import theme from 'theme/theme';
import type { StorageTwoOutputNodeData } from '../../../../../gojs/types';

const $ = go.GraphObject.make;

const getOutputPorts = (index: number) => {
  return $(
    go.Panel,
    'Auto',
    new go.Binding('itemArray', `P${index}`),
    {
      itemTemplate: OutputPort,
    },
    new go.Binding('alignment', '', () => {
      return index === 0 ? go.Spot.Right : go.Spot.Left;
    }),
  );
};

const StorageWith2OutputTemplate = makeNode(
  getImageBinding('storageWith2OutputImg', getImageStorageWith2Outputs),
  [
    getIOPort(go.Spot.Top, 'input'),
    getOutputPorts(0),
    getOutputPorts(1),
    $(
      go.Panel,
      'Auto',
      { alignment: new go.Spot(0.5, 1, 0, 8) },
      new go.Binding('visible', '', (data: StorageTwoOutputNodeData) => {
        const { massFlows, outputFlow } = data;
        if (!massFlows) {
          return false;
        }
        return outputFlow &&
          outputFlow?.totalMass >= 0 &&
          data.retainedAmount !== undefined
          ? true
          : false;
      }),
      $(go.Shape, 'RoundedRectangle', {
        strokeWidth: 0,
        fill: theme.palette.info.main,
        alignment: go.Spot.Bottom,
      }),
      $(
        go.TextBlock,
        {
          stroke: '#fff',
          alignment: go.Spot.Bottom,
          margin: new go.Margin(0, 2, 0, 2),
        },
        new go.Binding('text', '', (data: StorageTwoOutputNodeData) => {
          if (data.showProductPercentage) {
            return `${convertToCurrentMetric({
              value: data.retainedAmount,
              metricType: data.metricType,
              conversionType: CONVERSIONS.CAPACITY,
              decimals: 0,
            })} ${getMetricUnit(data.metricType, CONVERSIONS.CAPACITY)}${
              Number.isFinite(data.productPercentage)
                ? `, ${data.productPercentage}%`
                : ''
            }`;
          }
          return `${convertToCurrentMetric({
            value: data.retainedAmount,
            metricType: data.metricType,
            conversionType: CONVERSIONS.CAPACITY,
            decimals: 0,
          })} ${getMetricUnit(data.metricType, CONVERSIONS.CAPACITY)}`;
        }),
        new go.Binding('font', '', (data: StorageTwoOutputNodeData) => {
          return `normal normal 500 ${data.canvasBodyFontSize.size}px Sandvik Sans Text`;
        }),
      ),
    ),
  ],
);

export default StorageWith2OutputTemplate;
